import { MessageCircle, Instagram, ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";

export default function WhatsAppButton() {
  const { settings } = useStore();
  const navigate = useNavigate();
  const wa = settings?.whatsapp_number || "919999999999";
  const ig = settings?.instagram_url || "#";
  const msg = encodeURIComponent(
    "Hello PRIYARAA Concierge ✈️ — I'd love to know more about your jewellery collection."
  );

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      {/* Instagram */}
      <a
        data-testid="floating-instagram-button"
        href={ig}
        target="_blank"
        rel="noreferrer"
        className="group flex items-center gap-2 rounded-full bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] px-3.5 py-3 shadow-xl transition-transform hover:scale-105"
        aria-label="Follow PRIYARAA on Instagram"
      >
        <Instagram size={20} className="text-white" />
        <span className="hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium text-white transition-all group-hover:max-w-[7rem] sm:inline">
          Follow us
        </span>
      </a>

      {/* WhatsApp */}
      <a
        data-testid="floating-whatsapp-button"
        href={`https://wa.me/${wa}?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        className="group relative flex items-center gap-2 rounded-full bg-[#25D366] px-3.5 py-3 shadow-xl transition-transform hover:scale-105"
        aria-label="Chat with concierge on WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] pulse-ring" />
        <MessageCircle size={20} className="relative text-white" fill="white" />
        <span className="relative hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium text-white transition-all group-hover:max-w-[9rem] sm:inline">
          Chat with us
        </span>
      </a>

      {/* Shop / Buy */}
      <button
        data-testid="floating-shop-button"
        onClick={() => navigate("/shop")}
        className="group flex items-center gap-2 rounded-full gold-gradient px-4 py-3 font-semibold text-stone-900 shadow-xl transition-transform hover:scale-105"
        aria-label="Shop the collection"
      >
        <ShoppingBag size={20} className="text-stone-900" />
        <span className="text-sm font-semibold uppercase tracking-wide">Shop Now</span>
      </button>
    </div>
  );
}
